// actionCreator.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getloginService } from "../../../../utils/services/userLogin/loginService";
import { toast } from "react-toastify";
import { formatAndStorePermission } from "../../../../utils/functions/common";

export const getLogin = createAsyncThunk("/login", async (reqBody) => {
  const { error, payload } = await getloginService(reqBody);
  if (payload) {
    const token = payload?.token;
    const name = payload?.user?.name;
    const user = payload?.user;
    localStorage.setItem("token", token);
    localStorage.setItem("name", name);
    localStorage.setItem("user", JSON.stringify(user));

    formatAndStorePermission()

    // let permissionLevel = user?.subAdmin?.level?.levelPermission;

    // const outputObject = {};
    // permissionLevel.forEach((item) => {
    //   if (item.module && item.module.name) {
    //     const moduleName = item.module.name;
    //     const moduleData = {};

    //     if (item.read !== undefined) {
    //       moduleData.read = item.read;
    //     }
    //     if (item.write !== undefined) {
    //       moduleData.write = item.write;
    //     }

    //     outputObject[moduleName] = moduleData;
    //   }
    // });

    // localStorage.setItem("level", JSON.stringify(outputObject));
    return payload;
  }
});
